import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { MeterConfigurationData } from "../../../ThirdPartySystems.types";

function getSiemensColumns(): Array<MRT_ColumnDef<MeterConfigurationData>> {
  return [
    { header: "Name", accessorKey: "parameters.name", minSize: 180 },
    {
      header: "Name des Modells",
      accessorKey: "parameters.meterModel",
      minSize: 160,
      Cell: ({ renderedCellValue }) => renderedCellValue || "Unbekannt"
    },
    {
      header: "Typ der Messung",
      accessorKey: "parameters.measurementType",
      minSize: 160
    },
    {
      header: "Seriennummer",
      accessorKey: "parameters.serialNumber",
      size: 150
    },
    { header: "Einheit", accessorKey: "parameters.unit", size: 100 },
    {
      header: "Lesehäufigkeit in Sekunden",
      accessorKey: "parameters.readingFrequencyInSeconds",
      size: 130
    }
  ];
}

export { getSiemensColumns };
